import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const RegionRedirect = ({ targetPath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { regionId: regionUid } = useParams();
  const setSelectedRegion = useSelectedProfileStore((state) => state.setSelectedRegion);

  useEffect(() => {
    if (regionUid) {
      setSelectedRegion(regionUid);
      navigate(`${targetPath}${location.search}`, { replace: true });
    }
  }, [regionUid, navigate, setSelectedRegion, targetPath, location.search]);

  return null;
};

export default RegionRedirect;
